import CalloutBox from 'components/Docs/CalloutBox';
import * as React from 'react';
export default {
  CalloutBox,
  React
};